<template>
  <v-icon>
    {{ svgPath }}
  </v-icon>
</template>

<script>
import { mdiCheckboxMarked } from "@mdi/js";
export default {
  name: "MdiCheckboxMarked",
  data() {
    return {
      svgPath: mdiCheckboxMarked,
    };
  },
};
</script>
